import React from 'react'
import SectionTitle from '../components/section-title'
import GridContainer from '../components/grid-container'
import SectionContainer from '../components/section-container'
import PortfolioCard from '../components/Portfolio/portfolio-card'

const projects = [
  {
    title: 'Pinkaloo Dashboard',
    image: '/assets/images/portfolio/pinkaloo.jpg',
    tools: {
      React: 'bg-[url(../public/assets/images/logos/react.svg)]',
      'Redux-Toolkit': 'bg-[url(../public/assets/images/logos/redux.svg)]',
      'Node.js': 'bg-[url(../public/assets/images/logos/node.svg)]',
      'D3.js': 'bg-[url(../public/assets/images/logos/d3.svg)]',
      Jest: 'bg-[url(../public/assets/images/logos/jest.svg)]',
      Stylus: 'bg-[url(../public/assets/images/logos/stylus.svg)]',
    },
    description: 'Full Stack Developer',
    link: 'https://giving.pinkaloo.com/',
    github: '',
  },
  {
    title: 'I4Vision',
    image: '/assets/images/portfolio/i4vision.jpg',
    tools: {
      Laravel: 'bg-[url(../public/assets/images/logos/laravel.svg)]',
      PHP: 'bg-[url(../public/assets/images/logos/php.svg)]',
      Bootstrap: 'bg-[url(../public/assets/images/logos/bootstrap.svg)]',
    },
    description: 'Full Stack Developer',
    link: 'https://i4vision.de/',
    github: '',
  },
  {
    title: 'Soffos',
    image: '/assets/images/portfolio/soffos.jpg',
    tools: {
      React: 'bg-[url(../public/assets/images/logos/react.svg)]',
      'Redux-Toolkit': 'bg-[url(../public/assets/images/logos/redux.svg)]',
      TailwindCSS: 'bg-[url(../public/assets/images/logos/tailwindcss.svg)]',
      AWS: 'bg-[url(../public/assets/images/logos/aws.svg)]',
    },
    description: 'Full Stack Developer',
    link: 'https://soffos.ai/',
    github: '',
  },
  {
    title: 'Protest',
    image: '/assets/images/portfolio/protest.jpg',
    tools: {
      React: 'bg-[url(../public/assets/images/logos/react.svg)]',
      php: 'bg-[url(../public/assets/images/logos/php.svg)]',
    },
    description: 'Winter clothing shopping site',
    link: 'https://www.protest.eu/',
    github: '',
  },
  {
    title: 'ETQ',
    image: '/assets/images/portfolio/etq.jpg',
    tools: {
      'Next.js': 'bg-[url(../public/assets/images/logos/next.svg)]',
      'Redux-Toolkit': 'bg-[url(../public/assets/images/logos/redux.svg)]',
      Shopify: 'bg-[url(../public/assets/images/logos/shopify.svg)]',
    },
    description: 'ETQ takes a minimalist approach to ecommerce',
    link: 'https://www.etq-amsterdam.com/',
    github: '',
  },
  {
    title: 'Universal Monsters',
    image: '/assets/images/portfolio/universal_monsters.jpg',
    tools: {
      React: 'bg-[url(../public/assets/images/logos/react.svg)]',
      'Node.js': 'bg-[url(../public/assets/images/logos/node.svg)]',
      MongoDB: 'bg-[url(../public/assets/images/logos/mongodb.svg)]',
      Ethereum: 'bg-[url(../public/assets/images/logos/ethereum.svg)]',
      Binance: 'bg-[url(../public/assets/images/logos/binance.svg)]',
      Polygon: 'bg-[url(../public/assets/images/logos/polygon.svg)]',
    },
    description:
      'A Polygon blockchain technology-based merchandise collection store integrated with NFTs and advanced security features',
    link: 'https://universalmonsters.store/',
    github: '',
  },
  {
    title: 'Save Whales',
    image: '/assets/images/portfolio/save_whales.jpg',
    tools: {
      React: 'bg-[url(../public/assets/images/logos/react.svg)]',
      GSAP: 'bg-[url(../public/assets/images/logos/gsap.svg)]',
    },
    description:
      'A non-commercial project created to raise awareness of the endangered whale species',
    link: 'https://save-whales.com/',
    github: '',
  },
  {
    title: 'Cyberlionz',
    image: '/assets/images/portfolio/cyberlionz.png',
    tools: {
      Vue: 'bg-[url(../public/assets/images/logos/vue.svg)]',
      Nuxt: 'bg-[url(../public/assets/images/logos/nuxt.svg)]',
      'AWS Lambda': 'bg-[url(../public/assets/images/logos/aws-lambda.svg)]',
      TailwindCSS: 'bg-[url(../public/assets/images/logos/tailwindcss.svg)]',
      Solidity: 'bg-[url(../public/assets/images/logos/solidity.svg)]',
      Ethereum: 'bg-[url(../public/assets/images/logos/ethereum.svg)]',
    },
    description: 'NFT game with minting, staking, evolving and Unity integration',
    link: 'https://cyberlionz.io/',
    github: 'https://github.com/0xLe0x/cyberlionz/',
  },
  {
    title: 'Antonym Redeemer',
    image: '/assets/images/portfolio/antonym.jpg',
    tools: {
      Vue: 'bg-[url(../public/assets/images/logos/vue.svg)]',
      'AWS Lambda': 'bg-[url(../public/assets/images/logos/aws-lambda.svg)]',
      TypeScript: 'bg-[url(../public/assets/images/logos/typescript.svg)]',
      Shopify: 'bg-[url(../public/assets/images/logos/shopify.svg)]',
      Solidity: 'bg-[url(../public/assets/images/logos/solidity.svg)]',
      Ethereum: 'bg-[url(../public/assets/images/logos/ethereum.svg)]',
    },
    description: 'Collectors of Antonym Genesis NFTs are eligible to redeem for physical editions',
    link: 'https://redemption.antonymnft.com/',
    github: 'https://github.com/0xLe0x/antonym-nft/',
  },
  // {
  //   title: 'Darley',
  //   image: '/assets/images/portfolio/darley.jpg',
  //   tools: {
  //     react: 'bg-[url(../public/assets/images/logos/react.svg)]',
  //     redux: 'bg-[url(../public/assets/images/logos/redux.svg)]',
  //   },
  //   description: 'NFT gaming site',
  //   link: '#',
  // },
  {
    title: 'ProtoCalls',
    image: '/assets/images/portfolio/protocalls.jpg',
    tools: {
      React: 'bg-[url(../public/assets/images/logos/react.svg)]',
      'Redux-Toolkit': 'bg-[url(../public/assets/images/logos/redux.svg)]',
      TypeScript: 'bg-[url(../public/assets/images/logos/typescript.svg)]',
      TailwindCSS: 'bg-[url(../public/assets/images/logos/tailwindcss.svg)]',
    },
    description: 'Fetching crypto list using coinmarketcap api',
    link: '#',
    github: 'https://github.com/0xLe0x/CryptoList/',
  },
  {
    title: 'Eat The Odds',
    image: '/assets/images/portfolio/eattheodds.jpg',
    tools: {
      'Next.js': 'bg-[url(../public/assets/images/logos/next.svg)]',
      TypeScript: 'bg-[url(../public/assets/images/logos/typescript.svg)]',
      TailwindCSS: 'bg-[url(../public/assets/images/logos/tailwindcss.svg)]',
      Solidity: 'bg-[url(../public/assets/images/logos/solidity.svg)]',
      Ethereum: 'bg-[url(../public/assets/images/logos/ethereum.svg)]',
    },
    description: 'Eat the odds NFT minting site',
    link: 'https://eattheodds-demo.netlify.app/',
    github: 'https://github.com/0xLe0x/EatTheOdds',
  },
  {
    title: 'Dummy Products',
    image: '/assets/images/portfolio/dummy_products.jpg',
    tools: {
      React: 'bg-[url(../public/assets/images/logos/react.svg)]',
      'Redux-Toolkit': 'bg-[url(../public/assets/images/logos/redux.svg)]',
      TypeScript: 'bg-[url(../public/assets/images/logos/typescript.svg)]',
      TailwindCSS: 'bg-[url(../public/assets/images/logos/tailwindcss.svg)]',
    },
    description: 'Displaying dummy products info',
    link: '#',
    github: 'https://github.com/0xLe0x/dummy-products',
  },
]

const PortfolioSection = () => {
  return (
    <SectionContainer
      id="portfolio"
      addClass="bg-[linear-gradient(#000,rgba(0,0,0,0.93),rgba(0,0,0,0.66))] pb-20"
    >
      <SectionTitle>Portfolio</SectionTitle>
      <GridContainer>
        {projects.map((project, index) => (
          <PortfolioCard key={`portfolio-${index}`} {...project} />
        ))}
      </GridContainer>
    </SectionContainer>
  )
}

export default PortfolioSection
